import { defineSlotRecipe, defineStyles } from "@pandacss/dev";
import { fieldDefaultRecipeDefinition } from "./utils/fieldDefaultRecipeDefinition";
import textFieldStyles from "./utils/textFieldStyles";

const paddingLeftOnlyContainerStyles = defineStyles({
  paddingRight: "padding.0,5",
  paddingTop: "padding.0,5",
  paddingBottom: "padding.0,5",
  _disabled: {
    paddingRight: "calc({spacing.padding.0,5} + {borderWidths.m})",
    paddingTop: "calc({spacing.padding.0,5} + {borderWidths.m})",
    paddingBottom: "calc({spacing.padding.0,5} + {borderWidths.m})",
  },
});

const paddingRightOnlyContainerStyles = defineStyles({
  paddingTop: "padding.0,5",
  paddingBottom: "padding.0,5",
  paddingLeft: "padding.0,5",
  _disabled: {
    paddingTop: "calc({spacing.padding.0,5} + {borderWidths.m})",
    paddingBottom: "calc({spacing.padding.0,5} + {borderWidths.m})",
    paddingLeft: "calc({spacing.padding.0,5} + {borderWidths.m})",
  },
});

export const aromaInput = defineSlotRecipe({
  className: "aroma-input",
  jsx: ["Input", "DatePicker", "PasswordInput"],
  slots: ["input", "container"],
  base: {
    container: {
      ...fieldDefaultRecipeDefinition.base,
      alignItems: "center",
      "&:has([data-part=input]:focus-visible)": {
        shadow: "none",
        borderColor: "border.brand-bold",
      },
      "&.trigger-hovered": {
        _hover: {
          bg: "background.neutral.base.subtlest",
        },
      },
      _disabled: {
        cursor: "not-allowed",
      },
    },
    input: {
      ...textFieldStyles,
      width: "100%",
      border: "none",
      outline: "none",
      "&[type=number]": {
        appearance: "textfield",
        "&::-webkit-outer-spin-button,&::-webkit-inner-spin-button": {
          WebkitAppearance: "none",
          margin: 0,
        },
      },
    },
  },
  variants: {
    ...fieldDefaultRecipeDefinition.variants,
    size: {
      small: {
        ...fieldDefaultRecipeDefinition.variants?.size.small,
      },
      medium: {
        ...fieldDefaultRecipeDefinition.variants?.size.medium,
      },
    },
    paddingLeftOnly: {
      true: {
        container: paddingLeftOnlyContainerStyles,
      },
    },
    paddingRightOnly: {
      true: {
        container: paddingRightOnlyContainerStyles,
      },
    },
  },
  compoundVariants: [
    {
      size: "medium",
      paddingLeftOnly: true,
      css: {
        container: paddingLeftOnlyContainerStyles,
      },
    },
    {
      size: "medium",
      paddingRightOnly: true,
      css: {
        container: paddingRightOnlyContainerStyles,
      },
    },
    ...(fieldDefaultRecipeDefinition.compoundVariants ?? []),
  ],
  defaultVariants: { size: "small" },
});
